import styled from 'styled-components';

export const StyledLeftSide = styled.div`
  width: 34%;
  height: 100vh;
  overflow-y: visible;
  display: flex;
  justify-content: center;
  align-items: center;
`